import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'
import cloneDeep from 'lodash.clonedeep'
require('firebase/firestore')

Vue.use(Vuex)
export default new Vuex.Store({
  strict: true,
  state: {
    products: [],
    staticText: {banner: { title: '' }, contact: { bic: '', btw: '', email: '', iban: '', name: '', phone: '', rpr: '' }}
  },
  getters: {
    getStaticText: state => state.staticText,
    getProducts: state => cloneDeep(state.products).sort(function (a, b) { return a.id - b.id }),
    getCatagories: state => Array.from(new Set(state.products.map(x => x.category))).sort()
  },
  mutations: {
    mutAddProducts (state, payload) {
      state.products.push(payload)
    },
    mutFillStaticText (state, payload) {
      state.staticText = payload
    }
  },
  actions: {
    actContact (context, contactData) {
      console.log(contactData)
      firebase.firestore().collection('contact').add(contactData)
      .then(function (docRef) {
        console.log('Document written with ID: ', docRef.id)
      })
      .catch(function (error) {
        console.error('Error adding document: ', error)
      })
    },
    actFillProducts (context) {
      firebase.firestore().collection('product').onSnapshot(querySnapshot => {
        querySnapshot.forEach(doc => {
          var tempProd = doc.data()
          tempProd.id = doc.id
          context.commit('mutAddProducts', tempProd)
        })
      })
    },
    actFillStaticText (context) {
      var ref = firebase.firestore().collection('statictext')
      var texts = []
      ref.onSnapshot(querySnapshot => {
        querySnapshot.forEach(doc => {
          texts[doc.id] = doc.data()
        })
        context.commit('mutFillStaticText', texts)
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js